import { render, staticRenderFns } from "./SectionUserList.vue?vue&type=template&id=0bef56ba"
import script from "./SectionUserList.vue?vue&type=script&lang=js"
export * from "./SectionUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports